import React from 'react';
import '../../styles/styles.css';
import { Box, Typography, Fab } from '@mui/material';
import Grid from '@mui/material/Grid2';
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import ChatIcon from '@mui/icons-material/Chat';
import { PulseLoader } from 'react-spinners';
import PostCard from '../../components/posts/PostCard';
import { usePost } from '../../context/PostContext';
import { useNavigate } from 'react-router-dom';

const PostHomePage: React.FC = () => {
  const { filteredPosts, loading, error } = usePost();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", overflow: "hidden" }}>
      <main style={{ flex: 1 }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "80vh",
              backgroundColor: "#fafafa",
            }}
          >
            <PulseLoader color="#36d7b7" size={15} margin={2} />
            <Typography variant="h6" color="text.secondary" sx={{ mt: 3, textAlign: "center" }}>
              Cargando posts, por favor espera...
            </Typography>
          </Box>
        ) : error ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "80vh",
              textAlign: "center",
              gap: 2,
              backgroundColor: "#fafafa",
            }}
          >
            <NotInterestedIcon sx={{ fontSize: 75, color: "text.secondary" }} />
            <Typography variant="h6" color="error">
              Ocurrió un error
            </Typography>
            <Typography variant="body1" color="text.secondary">
              No pudimos cargar los posts. Por favor, inténtalo nuevamente más tarde.
            </Typography>
          </Box>
        ) : (
          <Box
            className="post-list"
            sx={{
              minHeight: "80vh",
              height: "auto",
              alignContent: filteredPosts.length > 0 ? "flex-start" : "center",
              p: 3,
            }}
          >
            {filteredPosts.length > 0 ? (
              <Grid container spacing={3}>
                {filteredPosts.map((post) => (
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }} key={post.id}>
                    <PostCard post={post} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "50vh",
                  textAlign: "center",
                  color: "text.secondary",
                  gap: 2,
                }}
              >
                <NotInterestedIcon sx={{ fontSize: 75, color: "text.secondary" }} />
                <Typography variant="h6">No hay posts en este momento.</Typography>
                <Typography variant="body1" color="text.secondary">
                  Intenta ajustar los filtros o vuelve más tarde para ver nuevos posts.
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </main>

      {/* FAB Chat */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <Fab
          variant="extended"
          color="success"
          sx={{
              position: "fixed",
              bottom: { xs: 150, sm: 65 }, 
              right: 16,
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "120px",
              height: "40px",
              borderRadius: "24px",
          }}
          onClick={() => navigate('/channelTest/home')}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>Chat</span>
            <ChatIcon />
          </div>
        </Fab>
      </Box>
    </Box>
  );
};

export default PostHomePage;
